import Navbar from '../components/Home/Navbar/Navbar'; 
import Section1 from '../components/Home/section1/section1'; 
import Section2 from '../components/Home/section2/section2';  

const Home = () => {
return (
    <>
        <Navbar />
        <Section1 />
        <Section2 /> 
    </>
);
};

export default Home;